<template>
  <PageLayout>
    <template #headerTitle> Coupons </template>
    <div class="flex flex-col h-full">
      <div class="px-6 md:px-8">
        <div class="max-w-4xl mx-auto">
          <!-- tabs navigation -->
          <div
            class="w-full rounded-full grid grid-cols-2 text-center bg-white mb-6 md:mb-8 relative"
          >
            <div
              class="absolute w-1/2 h-full duration-300 p-1"
              :class="{
                'translate-x-full': type == 'premium'
              }"
            >
              <div class="w-full h-full bg-[#E8E7FF] rounded-full"></div>
            </div>
            <div
              class="py-4 md:py-6 relative rounded-full font-bold text-sm md:text-md cursor-pointer"
              @click="type = 'free'"
            >
              Gratuit
            </div>
            <div
              class="py-4 md:py-6 relative rounded-full font-bold text-sm md:text-md cursor-pointer"
              @click="type = 'premium'"
            >
              Premium
            </div>
          </div>
          <ServicesList :group="type" />
        </div>
      </div>
      <CouponsList :type="type" />
    </div>
  </PageLayout>
</template>

<script setup>
import { ref } from 'vue';

const type = ref('free');
</script>
